// removed by extract-text-webpack-plugin
module.exports = {"ModalWindow":"ModalWindow","open":"open","dark":"dark","ModalWindow__link-close":"ModalWindow__link-close","light":"light"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-window/styles.css
// module id = 813
// module chunks = 0 1